import { render, staticRenderFns } from "./VDocumentationForm.vue?vue&type=template&id=2173dea8&"
import script from "./VDocumentationForm.vue?vue&type=script&lang=js&"
export * from "./VDocumentationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports